import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel, ShortModel } from '@data-layer/models/common';
import { AgentsSearchPagination } from '@app/modules/agents-management/models';
import { ManagementAgentModel, ManagementAgentSearchModel } from '../models/management/agents';
import {
  ManagementContainerFreightStorageModel,
  ManagementContainerFreightStorageSearchModel,
  ManagementUpdateContainerFreightStorageModel,
} from '@data-layer/models/management';

@Injectable({ providedIn: 'root' })
export class AgentsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(params: AgentsSearchPagination): Observable<PaginatedResultModel<ManagementAgentSearchModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementAgentSearchModel>>(
      `${environment.url.freight.agents}`,
      {
        params,
      },
      { isShowLoader: false },
    );
  }

  public searchVoyageAgents(params: PaginationSearchModel, voyageId: number): Observable<PaginatedResultModel<ManagementAgentSearchModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementAgentSearchModel>>(
      `${environment.url.freight.voyagesManagement}/${voyageId}/agents`,
      {
        params,
      },
      { isShowLoader: false },
    );
  }

  public get(id: number): Observable<ManagementAgentModel> {
    return this.apiService.get<ManagementAgentModel>(`${environment.url.freight.agents}/${id}`, {}, { isShowLoader: true });
  }

  public create(payload: Partial<ShortModel>): Observable<ShortModel> {
    return this.apiService.post<ShortModel>(`${environment.url.freight.agents}`, payload, {}, { isShowLoader: true });
  }

  public update(id: number, form: Partial<ShortModel>): Observable<ShortModel> {
    return this.apiService.put<ShortModel>(`${environment.url.freight.agents}/${id}`, form, {}, { isShowLoader: true });
  }

  public attachContact(agentId: number, contactId: number): Observable<void> {
    return this.apiService.post<void>(`${environment.url.freight.agents}/${agentId}/contacts/${contactId}`, {}, {}, { isShowLoader: true });
  }

  public detachContact(agentId: number, contactId: number): Observable<void> {
    return this.apiService.delete<void>(`${environment.url.freight.agents}/${agentId}/contacts/${contactId}`, {}, { isShowLoader: true });
  }

  public changeActivityStatus(id: number, status: boolean): Observable<void> {
    return this.apiService.post<void>(`${environment.url.freight.agents}/${id}/active`, status, {}, { isShowLoader: true });
  }

  public searchCFS(
    params?: ManagementContainerFreightStorageSearchModel,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<ManagementContainerFreightStorageModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementContainerFreightStorageModel>>(
      `${environment.url.freight.agents}/${params.agentId}/container-freight-storages`,
      { params },
      { isShowLoader },
    );
  }

  public createCFS(
    agentId: number,
    model: ManagementUpdateContainerFreightStorageModel,
    isShowLoader?: boolean,
  ): Observable<ManagementContainerFreightStorageModel> {
    return this.apiService.post<ManagementContainerFreightStorageModel>(
      `${environment.url.freight.agents}/${agentId}/container-freight-storages`,
      model,
      null,
      {
        isShowLoader,
      },
    );
  }
}
